import axios from "axios";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    Label,
} from "reactstrap";
import { environment } from "../../env";
import {
    successModalToggle,
    loaderAction,
    successInfoAction,
} from "../../redux/actions/Index";
import ErrorComponents from "../errorComponents/ErrorComponents";
import { ToWords } from 'to-words';
import moment from "moment";
import PriceFormater from "../../Helper/PriceFormater";
import Table from "../Table";
import SuccessPopups from "../Popups/SuccessPopups";
import { Printer } from "@phosphor-icons/react";
import { useNavigate } from 'react-router-dom';

function BillGeneratModal(props) {
    const dispatch = useDispatch();
    const [modal, setModal] = useState(false);
    const [btndis, setBtndis] = useState(true);
    const [amountPayError, setAmountPayError] = useState();
    const [totalRent, setTotalRent] = useState();
    const [billingTableData, setbillingTableData] = useState();
    const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
    const toggle = () => { setModal(!modal); getBillingData() };
    const navigate = useNavigate()
    const toWords = new ToWords();
    const details = props.details
    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm({ mode: "onChange" });
    const amountpayings = watch("amountpaying")

    const CancelButton = () => {
        toggle();
        setBtndis(true);
        reset();
        setAmountPayError("")
    };
    const CreateSubmit = async (data) => {
        dispatch(loaderAction())
        setBtndis(false)
        try {
            let payload = {
                "amountpay": parseFloat(amountpayings),
                "gala_investor": details.id,
                "tenant": details.rent[0]?.tenant?.id,
            }
            await axios.post(`${environment.baseUrl}update-rentpay`, payload).then((form) => {
                if (form.data.code === 200) {
                    dispatch(successModalToggle());
                    dispatch(loaderAction())
                    dispatch(successInfoAction("Payment Updated"))
                    getBillingData()
                    toggle();
                    reset();
                    setBtndis(true);
                }
                else {
                    setBtndis(true)
                }
            })
        }
        catch (err) {
            dispatch(loaderAction())
            console.log(err);
        }
    };
    const getBillingData = () => {
        dispatch(loaderAction())
        try {
            axios.get(`${environment.baseUrl}rentpay/${details.id}`).then((res) => {
                setbillingTableData(res.data)
            }).catch(res => {
                dispatch(loaderAction())
                console.log("error");
            })
        } catch (err) {
            dispatch(loaderAction());
            console.log(err);
        };
    }
    useEffect(() => {
        let totalamt = billingTableData?.reduce((total, rent) => total + parseFloat(rent.balance), 0)
        setTotalRent(totalamt)
        reset({
            "amountpaid": totalamt,
        })
    }, [billingTableData]);

    const columns = [
        {
            name: 'Month',
            selector: row => moment(row?.rent_date).format("MMM (YYYY)"),
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Amount',
            selector: row => <PriceFormater price={row?.amount} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Paid',
            selector: row => <PriceFormater price={row?.paid} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Balance',
            selector: row => <PriceFormater price={row?.balance} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Paid Date',
            selector: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <label className={row?.payment_date != null ? "icon-bg-green icon-color-green  rounded-pill status-box rounded fs-4" : "icon-bg-red icon-color-red  rounded-pill status-box rounded fs-3"}>{row?.payment_date != null ? moment(row?.payment_date).format('DD/MM/YYYY') : 'Not Paid'}</label>
            </div>,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Action',
            selector: row => <button
                onClick={() => navigatePrint(row)}
                className="bg-background-color border-0 p-3 rounded"
            >
                <Printer size="30" className="text-base-color" />
            </button>,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
    ];

    const navigatePrint = (data) => {
        let rentpay = []
        rentpay.push(data)
        navigate('/PrintPreview', { state: { pay: rentpay } })
    }

    const amountPay = (e) => {
        if (e.target.value > totalRent) {
            setAmountPayError("Amount is greater than balance")
            setBtndis(false)
        } else {
            setAmountPayError("")
            setBtndis(true)
        }
    }
    return (
        <>
            <SuccessPopups />
            <button
                onClick={toggle}
                className="bg-background-color border-0 p-3 rounded"
            >
                <Printer size="30" className="text-base-color" />
            </button>

            <Modal
                className="border-0"
                isOpen={modal}
                toggle={props.toggle}
                size="xl"
                centered

            >
                <ModalHeader className="bg-base-color " toggle={props.toggle}>
                    <span className="title-font-700 fs-36 text-base-white">
                        Paying Bills
                    </span>
                </ModalHeader>
                <Form
                    onSubmit={handleSubmit(CreateSubmit)}
                >
                    <ModalBody className="bg-background-color px-5">
                        <div className="row">
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Invester Name
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <label placeholder="Availabel Area.." className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white form-label">{details?.investor?.Investors?.name}</label>
                                </div>
                                <br />
                            </div>
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Tenant Name
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <label placeholder="Availabel Area.." className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white form-label">{details?.proposal?.name_of_company}</label>
                                </div>
                                <br />
                            </div>
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Project Name
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <label placeholder="Availabel Area.." className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white form-label">{details?.investor?.project?.name}</label>
                                </div></div>
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Building Name
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <label placeholder="Availabel Area.." className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white form-label">{details?.investor?.building?.building_no}</label>
                                </div>
                                <br />
                            </div>
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Gala No
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <label placeholder="Availabel Area.." className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white form-label">{details?.investor?.gala?.gala_no}</label>
                                </div>
                                <br />
                            </div>
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Area
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <label placeholder="Availabel Area.." className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white form-label">{details?.required_area} Sq.ft</label>
                                </div>
                                <br />
                            </div>
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                    Balance
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <label placeholder="Availabel Area.." className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white form-label">{<PriceFormater price={totalRent} />}</label>
                                </div>
                                {
                                    totalRent &&
                                    <>
                                        <small className="fs-2 title-font-600 text-left"><span className="text-black">{toWords.convert(totalRent)}</span></small>
                                        <br />
                                    </>
                                }
                                <br />
                            </div>
                            <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                <Label className="fs-4 title-font-800 mb-0 text-base-color">
                                    Amount Paying
                                </Label>
                                <br />
                                <div className="mt-1  d-flex gap-3">
                                    <div className="numberTextSuffixPrice w-100">
                                        <input
                                            className={totalRent == 0 ? "p-3  border-radius-10  w-100 fs-4 title-font-800 fs-2 modal-input bg-white " : "p-3  border-radius-10  w-100 fs-4 title-font-800 fs-2 modal-focus bg-white"}
                                            type="number"
                                            maxLength={15}
                                            min={0}
                                            onKeyDown={preventNegativeValues}
                                            placeholder="Enter Amount Paying"
                                            {...register("amountpaying", { required: true, onChange: (e) => { amountPay(e) } })}
                                            disabled={totalRent == 0 ? true : false}
                                        />
                                    </div>
                                </div>
                                {errors.amountpaying && (
                                    <ErrorComponents error={"Amount Paying is required *"} />
                                )}

                                {amountPayError && (
                                    <ErrorComponents error={amountPayError} />
                                )}
                                {
                                    !amountPayError && amountpayings &&
                                    <>
                                        <br />
                                        <small className="fs-2 title-font-600 text-left"><span className="text-black">{toWords.convert(amountpayings)}</span></small>
                                        <br />
                                    </>
                                }
                                <br />
                            </div>
                        </div>
                        <div className="bg-white p-4 rounded-5 mb-5 shadow-sm">
                            <h2 className="fs-2 title-font-700 text-base-color">Payment Mode</h2>
                            <div className="row align-items-center">
                                <div className='col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1'>
                                    <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                                        Select Payment Mode
                                    </Label>
                                    <br />
                                    <div className='mt-1  d-flex gap-3'>
                                        <select id="proposal" name="role_type" className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                            {...register("payment_mode")}>
                                            <option value="">Select Payment Mode</option>
                                            <option value="Cash">Cash</option>
                                            <option value="Checks">Check</option>
                                            <option value="Debit card">Debit card</option>
                                            <option value="Credit card">Credit card</option>
                                            <option value="Mobile payment">Mobile payment</option>
                                            <option value="Netbanking">Netbanking</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-11 mx-auto mx-md-0 col-md-6 col-lg-6 col-xl-6 pb-3 pt-1">
                                    <Label className="fs-4 title-font-500 mb-0 text-base-color">
                                        Receiver Name
                                    </Label>
                                    <br />
                                    <div className="mt-1  d-flex gap-3">
                                        <input
                                            className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                            type="text"
                                            placeholder="Receiver Name..."
                                            {...register("receivier_name", { required: true })}
                                        />
                                    </div>
                                    {errors.receivier_name && (
                                        <ErrorComponents error={"Receivier Name is required *"} />
                                    )}
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div className="pt-5">
                            {
                                billingTableData?.length > 0 ? <Table columns={columns} data={billingTableData} /> : <h3 className="fs-3 text-center">No Bill !</h3>
                            }

                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            type="button"
                            className="border-radius-7 p-3 d-flex align-items-center buttons-outline"
                            onClick={CancelButton}
                        >
                            <span className="fs-5 d-flex gap-3 title-font-600 px-3">
                                Cancel
                            </span>
                        </Button>{" "}
                        <Button
                            className="border-radius-7 p-3 d-flex align-items-center buttons"
                            disabled={!btndis}
                        >
                            <span className="fs-5 d-flex gap-3 title-font-600 px-3">
                                Save
                            </span>
                        </Button>
                    </ModalFooter>
                </Form>
            </Modal >
        </>
    );
}

export default BillGeneratModal;
